import React, { useState, useEffect } from "react";
import AdminToolsDataService from "../../../services/admin-tools.service";
import ExecuteSolrIndexing from "../../../services/admin-tools.service"
import { NotificationManager } from "react-notifications";
import { useTranslation } from "react-i18next";
import { Select, Spin, Table, Button } from "antd";
import { ReloadOutlined } from "@ant-design/icons";

const { Option } = Select;

const SolrCoreIndexer = () => {
    const { t } = useTranslation();
    const [indexerHistory, setIndexerHistory] = useState([]);
    const [loading, setLoading] = useState(false);
    const [pageNo, setPageNo] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [totalCount, setTotalCount] = useState(0);
    const [filterBy, setFilterBy] = useState("0");
    const [statusMessage, setStatusMessage] = useState("");

    useEffect(() => {
        handleGetSolrCoreIndexerHistory();
    }, [filterBy, pageNo, pageSize]);

    const handleGetSolrCoreIndexerHistory = () => {
        setLoading(true);
        AdminToolsDataService.GetClientList({ FilterBy: filterBy,  PageNumber : pageNo, PageSize : pageSize })
            .then((response) => {
                setLoading(false);
                if (response.data.status && response.data.responseData) {
                    setIndexerHistory(response.data.responseData);
                    setTotalCount(response?.data?.responseData?.[0]?.totalCount);
                    setStatusMessage("");
                } else {
                    setIndexerHistory([]);
                    setTotalCount(0);
                    setStatusMessage("No data found");
                }
            })
            .catch((error) => {
                console.log(error);
                setLoading(false);
                setIndexerHistory([]);
                setStatusMessage("Error loading data");
            })
            .finally(() => {
                setLoading(false);
            });
    };


    const handleExecuteIndexer = async (queueId) => {
        setLoading(true);
        try {
            const response = await AdminToolsDataService.ExecuteSolrIndexing( queueId );

            if (response?.data?.status) {
                NotificationManager.success(t("Solr Core Indexer executed successfully."));
                handleGetSolrCoreIndexerHistory(filterBy, pageNo, pageSize);
            } else {
                NotificationManager.error(
                    t(response?.data?.message || "Failed to execute Solr Core Indexer")
                );
            }
        } catch (error) {
            console.error("Execution error:", error);
            NotificationManager.error(t("Failed to execute Solr Core Indexer"));
        } finally {
            setLoading(false);
        }
    };


    const handleRefreshData = () => {
        handleGetSolrCoreIndexerHistory(filterBy, pageNo, pageSize);
    };

    const columns = [
        {
            title: t("Queue ID"),
            dataIndex: "id",
            key: "id",
            sorter: (a, b) => a.id - b.id,
            showSorterTooltip: false,
        },
        {
            title: t("Retailer ID"),
            dataIndex: "retailerID",
            key: "retailerID",
            render: (text) => (text === 0 || !text ? "-" : text),
            sorter: (a, b) => (a.retailerID || 0) - (b.retailerID || 0),
            showSorterTooltip: false,
        },
        {
            title: t("Retailer Name"),
            dataIndex: "dealerCompany",
            key: "dealerCompany",
            render: (text) => (!text || text === "" ? "-" : text),
            sorter: (a, b) => (a.dealerCompany || "").localeCompare(b.dealerCompany || ""),
            showSorterTooltip: false,
        },
        {
            title: t("Vendor ID"),
            dataIndex: "vendorID",
            key: "vendorID",
            render: (text) => (text === null || !text ? "-" : text),
            sorter: (a, b) => (a.vendorID || 0) - (b.vendorID || 0),
            showSorterTooltip: false,
        },
        {
            title: t("Vendor Name"),
            dataIndex: "vendorName",
            key: "vendorName",
            render: (text) => (!text || text === "" ? "-" : text),
            sorter: (a, b) => (a.vendorName || "").localeCompare(b.vendorName || ""),
            showSorterTooltip: false,
        },
        {
            title: t("Date Created"),
            dataIndex: "dateCreated1",
            key: "dateCreated1",
            sorter: (a, b) => new Date(a.dateCreated1) - new Date(b.dateCreated1),
            showSorterTooltip: false,
        },
        {
            title: t("Date Completed"),
            dataIndex: "dateCompleted",
            key: "dateCompleted",
            render: (text) => (!text || text === "" ? "-" : text),
            sorter: (a, b) => new Date(a.dateCompleted || 0) - new Date(b.dateCompleted || 0),
            showSorterTooltip: false,
        },
        {
            title: t("Action"),
            key: "action",
            render: (_, record) => (
                <Button
                    type="primary"
                    size="small"
                    onClick={() => handleExecuteIndexer(record.id)}
                    disabled={record.isCompleted}
                    style={{ display: record.isCompleted ? "none" : "block" }}
                >
                    {t("Execute")}
                </Button>
            ),
        },
    ];

    const handleFilterChange = (value) => {
        setFilterBy(value);
        setPageNo(1);
        setPageSize(10);
    };

    return (
        <React.Fragment>
            <div className="newretailer_section SolrCore">
                <div className="form__fields">
                    <div className="row">
                        <div className="col-lg-12">
                            <h4 className="workarea__heading mt-0 mb-0">
                                {t("Solr Core Indexer")}
                            </h4>
                        </div>

                        {/* Header Section */}
                        <div className="col-lg-12 mt-4">
                            <div className="solrHeaderDiv" style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                padding: "15px",
                                backgroundColor: "#f8f9fa",
                                borderRadius: "8px",
                                marginBottom: "20px"
                            }}>
                                <div className="col-lg-3 mt-4 mobile-m-0">
                                    <div className="input__block mb-0">
                                        <label>
                                            {t("Select From Queue")} <span className="mandatory">*</span>
                                        </label>
                                        <Select
                                            value={filterBy}
                                            name="filterBy"
                                            showSearch={false}
                                            placeholder={t("Select From Queue")}
                                            optionFilterProp="children"
                                            onChange={handleFilterChange}
                                            className="border__grey"

                                        >
                                            <Option value="0">{t("Load Pending")}</Option>
                                            <Option value="1">{t("Load All")}</Option>
                                        </Select>
                                    </div>
                                </div>

                                <div className="rightDiv">
                                    <Button
                                        type="primary"
                                        icon={<ReloadOutlined />}
                                        onClick={handleRefreshData}
                                        loading={loading}
                                    >
                                        {t("Refresh Data")}
                                    </Button>
                                </div>
                            </div>
                        </div>

                        {/* Content Section */}
                        <div className="col-lg-12">
                            <div className="solrContentDiv">
                                {/* Status Message */}
                                {statusMessage && (
                                    <div className="messageDiv" style={{
                                        marginBottom: "15px",
                                        padding: "10px",
                                        backgroundColor: statusMessage.includes("Error") ? "#fff2f0" : "#f6ffed",
                                        border: statusMessage.includes("Error") ? "1px solid #ffccc7" : "1px solid #b7eb8f",
                                        borderRadius: "6px"
                                    }}>
                                        <span style={{
                                            color: statusMessage.includes("Error") ? "#cf1322" : "#389e0d",
                                            fontSize: "15px"
                                        }}>
                                            {statusMessage}
                                        </span>
                                    </div>
                                )}

                                {/* Grid Section */}
                                <div className="gridDiv">
                                    <Spin spinning={loading} size="large">
                                        <Table
                                            columns={columns}
                                            dataSource={indexerHistory}
                                            rowKey="id"
                                            pagination={{
                                                size: "small",
                                                total: totalCount,
                                                current: pageNo,
                                                pageSize: pageSize,
                                                pageSizeOptions: [10, 25, 50, 100],
                                                responsive: true,
                                                showSizeChanger: true,
                                                showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
                                                onChange: (newPage, newSize) => {
                                                    setPageNo(newPage);
                                                    setPageSize(newSize);
                                                },
                                            }
                                            }
                                        />


                                    </Spin>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default SolrCoreIndexer;